export interface ILegalFormAndAccountBasisCombinationCheck {
    legalForm: string;
    accountBasis: string;
    id: string;
    owner: string;
}
